import { render } from "./XAxis.vue?vue&type=template&id=6f16919b"
import script from "./XAxis.vue?vue&type=script&lang=js"
export * from "./XAxis.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__